/* global axios */
import ApiClient from './ApiClient';

class CampaignsAPI extends ApiClient {
  constructor() {
    super('campaigns', { accountScoped: true });
  }

  getDeliveries(campaignId, params = {}) {
    return axios.get(`${this.baseUrl()}/seggna/campaign_deliveries`, {
      params: { ...params, campaign_id: campaignId },
    });
  }
}

export default new CampaignsAPI();
